module.exports = __webpack_public_path__ + "static/logo-085a82aa99f624c78b78e43706026415.png";